import { z } from "zod";
import { DELIVERY_FEES_OPTIONS_ENUM } from "../../../types/order";

export const createNewCatalogSchema = z.object({
    catalogType: z.string(),
    catalogName: z.string().min(1),
    tags: z.string().array().optional(),
    business: z.string(),
    hidePrice: z.boolean(),
    items: z.object({}).optional(),
    deliveryFeesType: z.nativeEnum(DELIVERY_FEES_OPTIONS_ENUM),
    feesAmount: z.number().min(0)
});

export const multiImageTableSchema = z.object({
    meta_data: z.object({
        sku: z.string(),
        fileName: z.string(),
        product: z.object({
            id: z.string().min(2, { message: "Select Product" }),
            productName: z.string().min(2, { message: "Select Product" }),
            sku: z.string().min(2, { message: "Select Product" }),
        }),
        imageType: z.string().min(4, { message: "Select Image type" }),
        blobUrl: z.string()
    }).array()
})